export const removeAdditionalSpaces = (text: string) => text.replace(/\s{2,}/g, " ");
export const removeAdditionalSpaces = (text: string) => text.replace(/\s{2,}/g, " ");
